__turbopack_context__.v({
  "backdrop": "MxnSyW_backdrop",
  "body": "MxnSyW_body",
  "bodyNoOverflow": "MxnSyW_bodyNoOverflow",
  "bodyNoPadding": "MxnSyW_bodyNoPadding",
  "content": "MxnSyW_content",
  "fullHeight": "MxnSyW_fullHeight",
  "hideTitleOnDesktop": "MxnSyW_hideTitleOnDesktop",
  "slideInFromBottom": "MxnSyW_slideInFromBottom",
  "slideInFromLeft": "MxnSyW_slideInFromLeft",
  "slideInFromRight": "MxnSyW_slideInFromRight",
  "slideOutToBottom": "MxnSyW_slideOutToBottom",
  "slideOutToLeft": "MxnSyW_slideOutToLeft",
  "slideOutToRight": "MxnSyW_slideOutToRight",
  "surface": "MxnSyW_surface",
  "topTitleBar": "MxnSyW_topTitleBar",
  "wrapper": "MxnSyW_wrapper",
});
